import { useGetBeaconTabs } from './useGetBeaconTabs';
import { BeaconTab } from '../types';
import { useQueryParams } from '../../../Hooks/useQueryParams';

const NO_TABS: BeaconTab[] = [];

type UseBeaconPageLogicResult =
  | { status: 'loading' }
  | { status: 'error'; errorMessage: string }
  | {
      status: 'success';
      tabs: BeaconTab[];
      activeTabKey: string;
      onTabChange: (tabKey: string) => void;
    };

export const useBeaconPageLogic = (): UseBeaconPageLogicResult => {
  const tabsResult = useGetBeaconTabs();
  const [queryParams, updateQueryParams] = useQueryParams<'tab'>();

  const tabs = tabsResult.status === 'success' ? tabsResult.tabs : NO_TABS;

  // The active tab lives in `?tab=`, so a refresh or deep-link lands on the same
  // tab; an absent or unrecognised key falls back to the first available tab.
  const activeTabKey = (tabs.find(tab => tab.key === queryParams.tab) ?? tabs[0])?.key ?? '';

  const onTabChange = (tabKey: string) => {
    if (tabs.some(tab => tab.key === tabKey)) {
      updateQueryParams({ ...queryParams, tab: tabKey });
    }
  };

  if (tabsResult.status === 'loading') {
    return { status: 'loading' };
  }

  if (tabsResult.status === 'error') {
    return { status: 'error', errorMessage: tabsResult.error };
  }

  return {
    status: 'success',
    tabs,
    activeTabKey,
    onTabChange,
  };
};
